export default class DollarUtil {
    static formatDollar(amount: number): string {
        // Round to 2 decimal places
        const rounded = Math.round(amount * 100) / 100;
        
        // Check if it's a whole number (no decimals)
        const isWholeNumber = rounded % 1 === 0;
        
        // Format with commas
        const formatted = rounded.toLocaleString('en-US', {
            minimumFractionDigits: isWholeNumber ? 0 : 2,
            maximumFractionDigits: 2
        });
        
        return `$${formatted}`;
    }
}
